import React from "react";
import PropTypes from "prop-types";

/*
  TODO do actions in this style?
  actions={{
    cancel: {
      label: string | default,
      color: string | default,
      action: func,
      display: boolean
      ...
    },
    ...
  }}
*/

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const Modal = ({
  open,
  title,
  children,
  actions,
  onClose,
  maxWidth,
  contentSx = {},
  ...rest
}) => {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      PaperProps={{ sx: { maxWidth: maxWidth } }}
      {...rest}
    >
      {title && <DialogTitle id="modal-title">{title}</DialogTitle>}
      <DialogContent dividers sx={contentSx}>
        {children}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

Modal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  actions: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  maxWidth: PropTypes.string,
  contentSx: PropTypes.object,
};

export default Modal;
